import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { GET_TOP_OPERATE } from "../../../constant-value";
import api from "../../../services/axiosConfig";
import { calculateDateDiff } from "../../pages/dateDiff";
import OperateCard from "../OperateCard/OperateCard";
import styles from "./OperateHome.module.css";
import EmptyDashboardCard from "../EmptyDashboardCard/EmptyDashboardCard";


const OperateHome = () => {
    const [operate, setOperate] = useState([]);
    const [isLoadingOp, setIsLoadingOp] = useState(true);

    const scrollRef = useRef(null);

    const isDragging = useRef(false);
    const startX = useRef(0);
    const startScrollLeft = useRef(0);


    const getOperats = () => {
        api
            .get(`${GET_TOP_OPERATE}`)
            .then((response) => {
                setOperate(response.data.operates);
            })
            .catch((reason) => {
                alert(reason);
            })
            .finally(() => {
                setIsLoadingOp(false);
            });
    };


    useEffect(() => {
        getOperats();
    }, []);


    const handleMouseDown = (event) => {
        const slider = scrollRef.current;

        if (!slider) {
            return;
        }

        isDragging.current = true;

        startX.current = event.clientX;

        startScrollLeft.current =
            slider.scrollLeft;

        slider.classList.add(styles.dragging);
    };


    const handleMouseMove = (event) => {
        if (!isDragging.current) {
            return;
        }

        const slider = scrollRef.current;

        if (!slider) {
            return;
        }

        const distance =
            event.clientX - startX.current;

        slider.scrollLeft =
            startScrollLeft.current - distance;
    };


    const stopDragging = () => {
        if (!isDragging.current) {
            return;
        }

        isDragging.current = false;

        const slider = scrollRef.current;

        if (slider) {
            slider.classList.remove(styles.dragging);
        }
    };


    const handleWheel = (event) => {
        const slider = scrollRef.current;

        if (!slider) {
            return;
        }

        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
            slider.scrollLeft += event.deltaY;
            event.preventDefault();
        }
    };


    if (isLoadingOp) {
        return (
            <p>
                در حال بارگذاری...
            </p>
        );
    }


    if (operate.length === 0) {
        
        return (

            <EmptyDashboardCard/>

            // <Link
            //     type="button"
            //     className="btn btn-info btn-lg text-white w-100"
            //     to="/add-service"
            // >
            //     سرویس جدید
            // </Link>
        );
    }


    return (
        <div className="container my-3 px-0">
            <div
                ref={scrollRef}
                className={styles.operateScroll}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={stopDragging}
                onMouseLeave={stopDragging}
                onWheel={handleWheel}
            >
                {operate.map((service) => {
                    const result =
                        calculateDateDiff(service);

                    return (
                        <div
                            key={service.id}
                            className={styles.operateSlide}
                        >
                            <OperateCard
                                service={service}
                                min={result.min}
                                max={result.max}
                                now={result.now}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};


export default OperateHome;